import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { GlobalProvider } from "./contexts/GlobalContext.js";
import Cookies from "js-cookie";
import NavbarMargin from "./assets/NavbarMargin.js";
import Navbar from "./components/Navbar.js";
import Footer from "./components/Footer.js";
import VacancyDetail from "./pages/VacancyDetail.js";
import Vacancy from "./pages/Vacancy.js";
import AboutMe from "./pages/AboutMe.js";
import Apply from "./pages/Apply.js";
import Login from "./pages/Login.js";
import Register from "./pages/Register.js";
import Home from "./pages/Home.js";
import DataTableList from "./pages/DataTableList.js";
import AddJobVacancy from "./pages/AddJobVacancy.js";
import Profile from "./pages/Profile.js";
import ChangePassword from "./pages/ChangePassword.js";
import Logout from "./pages/Logout.js";
import Dashboard from "./pages/Dashboard.js";
import Layout from "./components/Layout.js";
import Layout2 from "./components/Layout2.js";

const App = () => {
  const LoginDashboard = (props) => {
    if (Cookies.get("token") === undefined) {
      return props.children;
    } else if (Cookies.get("token") !== undefined) {
      return <Navigate to={"/"} />;
    }
  };

  const ProtectedRoute = ({ element }) => {
    const token = Cookies.get("token");
    if (!token) {
      alert("Login dulu Bang");
      return <Navigate to="/Login" />;
    }
    return element;
  };

  return (
    <BrowserRouter>
      <GlobalProvider>
        <Navbar />
        <NavbarMargin />
        <Routes>
          <Route
            path="/"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          <Route path="/Vacancy" element={<Vacancy />} />
          <Route path="/Vacancy/:id" element={<VacancyDetail />} />
          <Route path="/About" element={<AboutMe />} />
          <Route path="/Apply" element={<Apply />} />
          <Route
            path="/Login"
            element={
              <LoginDashboard>
                <Layout>
                  <Login />
                </Layout>
              </LoginDashboard>
            }
          />
          <Route
            path="/Dashboard"
            element={
              <ProtectedRoute
                element={
                  <Layout2>
                    <Dashboard />
                  </Layout2>
                }
              />
            }
          />
          <Route
            path="/DataTableList"
            element={
              <ProtectedRoute
                element={
                  <Layout2>
                    <DataTableList />
                  </Layout2>
                }
              />
            }
          />
          <Route
            path="/addJobVacancy"
            element={
              <ProtectedRoute
                element={
                  <Layout2>
                    <AddJobVacancy />
                  </Layout2>
                }
              />
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute
                element={
                  <Layout2>
                    <Profile />
                  </Layout2>
                }
              />
            }
          />
          <Route
            path="/changePassword"
            element={
              <ProtectedRoute
                element={
                  <Layout2>
                    <ChangePassword />
                  </Layout2>
                }
              />
            }
          />
          <Route
            path="/logout"
            element={
              <ProtectedRoute
                element={
                  <Layout>
                    <Logout />
                  </Layout>
                }
              />
            }
          />
          <Route path="/Register" element={<Register />} />
        </Routes>
        <Footer />
      </GlobalProvider>
    </BrowserRouter>
  );
};

export default App;
